var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { forwardRef } from "react";
import { createPolymorphicComponent } from "../utils/types/polymorphic-component";
export const DEFAULT_TYPOGRAPHY_TAG = "span";
const _Typography = forwardRef((_a, ref) => {
    var { component = DEFAULT_TYPOGRAPHY_TAG } = _a, rest = __rest(_a, ["component"]);
    const Component = component;
    return React.createElement(Component, Object.assign({ ref: ref }, rest));
});
export const Typography = createPolymorphicComponent(_Typography);
